<template>
    <b-container fluid class="p-3">
        <b-row class="no-gutters mb-4">
            <b-col v-if="!loadingAccountChoices">
                <grid class="w-100" :isAutoHeight="true" :columnDefs="columnDefs" :rowData="accountChoices" :isSearch="false">
                </grid>
            </b-col>
            <b-col v-else>
                <busy-modal :show="true"></busy-modal>
            </b-col>
        </b-row>        
    </b-container>
</template>

<script>
import { mapGetters } from 'vuex';
import BusyModal from '../generic/busy-modal/busy-modal.vue';
import Grid from '../generic/grid/grid.vue';
export default {
    name: 'AccountChart',
    components: {
        BusyModal,
        Grid,
    },
    computed: {
        ...mapGetters('quickbooks', ['accountMapping', 'accountChoices', 'loadingAccountChoices']),
        columnDefs() {
            return [
                {
                    field: 'account_number',
                    headerName: 'Account Number',
                },
                {
                    field: 'name',
                    headerName: 'Name',
                    cellRenderer: ({ data }) => (data.is_subaccount ? `&nbsp;&nbsp;&nbsp;${data.name}` : data.name),
                },
                {
                    field: 'acct_type',
                    headerName: 'Account Type',
                },
            ];
        },
    },
    async mounted() {
        await this.fetchData();
    },
    methods: {
        async fetchData() {
            try {
                this.$parent.$emit('busy', true);
                if (!this.accountChoices || this.accountChoices.length === 0) {
                    await this.fetchAccountChoices();
                    await this.fetchAccountMapping();
                }
            } catch (e) {
                const { generic } = formatResponseError(e);
                this.errorToast({ text: generic || 'Could not fetch accounts data' });
            } finally {
                this.$parent.$emit('busy', false);
            }
        },
        async fetchAccountChoices() {
            try {
                await this.$store.dispatch('quickbooks/fetchAccountChoices');
            } catch (e) {
                this.errorToast({ text: 'Could not fetch account choices' });
            }
        },
        async fetchAccountMapping() {
            try {
                await this.$store.dispatch('quickbooks/fetchAccountMapping');
            } catch (e) {
                this.errorToast({ text: 'Could not fetch account mapping' });
            }
        },
    },
};
</script>

<style scoped>
/* Your component styles here */
</style>
